<template>
<div style="height：100%;">
  <iframe
    ref="iframe"
    src="http://www.00800.com.cn/cnhs/wqproject/index.php?app=public&mod=PCNew&act=contact"
    frameborder="0"
    class="ifr_warp"
  ></iframe>
</div>
</template>

<script>
export default {
 
};
</script>

<style lang="scss" scoped>
.ifr_warp{
  width:80%;
  max-width: 1120px;
  min-height: 800px;
  height: 100%;
  margin:30px auto;
}
</style>
